/* eslint-disable @typescript-eslint/no-empty-object-type */
// TODO: Base interfaces on the generated types from the backend
import { ConfiguratorOptionGroup, type ConfiguratorPriceTableItem, ListOption, ListOptionCategory as ListOptionCategoryOriginal, ListOptionItem as ListOptionItemOriginal, NumberOption, type OptionVisibility, RALColorOption, TextInfoOption, TextOption } from "#models/Configurator"
import { type ConfiguratorCategoryView, type ConfiguratorGeneralView, type ConfiguratorListEntryView, type ConfiguratorOptionEntryView, ConfiguratorOptionGroupEntryView } from "#resources/Admin/Configurator/Views"
import type { ShopListEntryView } from "#resources/Admin/Shop"
import type { StringId } from "effect-app/Schema"
import * as Struct from "effect/Struct"
import { S } from "~~/utils/prelude"

export type NonEmpty<T> = readonly T[] & { 0: T }

export type ShopListEntry = ShopListEntryView

export type ConfiguratorListEntry = ConfiguratorListEntryView
export type ConfiguratorGeneral = ConfiguratorGeneralView

interface OptionExt {
  optionGroup: ConfiguratorOptionGroupEntryView
  activateAt: Date | null
}

// eslint-disable-next-line
export interface OptionBase extends OptionExt {
  id: StringId
  externalId: string | null
  code: string
  name: string
  description: string | null
  tooltip: string | null
  note: string | null
  priceFormula: string | null
  priceTableId: string | null
  isEnabled: boolean // remove?
  isRequired: boolean
  visibility: OptionVisibility
  isReadonly: boolean
  focussedImageUrl: string | null
}

export class ListOptionCategory extends S.Opaque<ListOptionCategory, ListOptionCategory.Encoded>()(
  S
    .Struct({
      ...Struct.omit(ListOptionCategoryOriginal.fields, ["timestamps"])
    })
    .annotate({ identifier: "ListOptionCategory" })
) {}

export declare namespace ListOptionCategory {
  export interface Encoded extends S.Struct.Encoded<typeof ListOptionCategory["fields"]> {}
}

/** A configurator enriched with the data of the category it belongs to */
export interface ConfiguratorWithCategory extends ConfiguratorListEntry {
  category: ConfiguratorCategoryView | null
}

export class ListOptionItem extends S.Opaque<ListOptionItem, ListOptionItem.Encoded>()(
  S
    .Struct({
      ...Struct.omit(ListOptionItemOriginal.fields, ["timestamps", "categoryId"]),
      category: S.NullOr(ListOptionCategory)
    })
    .annotate({ identifier: "ListOptionItem" })
) {}

export declare namespace ListOptionItem {
  export interface Encoded extends S.Struct.Encoded<typeof ListOptionItem["fields"]> {}
}

export class ListOptionType extends S.Opaque<ListOptionType, ListOptionType.Encoded>()(
  S
    .Struct({
      ...Struct.omit(ListOption.fields, ["timestamps", "items", "categories"]),
      items: S.Array(ListOptionItem),
      optionGroup: ConfiguratorOptionGroupEntryView,
      categories: S.Array(ListOptionCategory)
    })
    .annotate({ identifier: "ListOptionType" })
) {}

export declare namespace ListOptionType {
  export interface Encoded extends S.Struct.Encoded<typeof ListOptionType["fields"]> {}
}

export class NumberOptionType extends S.Opaque<NumberOptionType, NumberOptionType.Encoded>()(
  S
    .Struct({
      ...Struct.omit(NumberOption.fields, ["timestamps"]),
      optionGroup: ConfiguratorOptionGroupEntryView
    })
    .annotate({ identifier: "NumberOptionType" })
) {}

export declare namespace NumberOptionType {
  export interface Encoded extends S.Struct.Encoded<typeof NumberOptionType["fields"]> {}
}

export class TextOptionType extends S.Opaque<TextOptionType, TextOptionType.Encoded>()(
  S
    .Struct({
      ...Struct.omit(TextOption.fields, ["timestamps"]),
      optionGroup: ConfiguratorOptionGroupEntryView
    })
    .annotate({ identifier: "TextOptionType" })
) {}

export declare namespace TextOptionType {
  export interface Encoded extends S.Struct.Encoded<typeof TextOptionType["fields"]> {}
}

export class RalColorOptionType extends S.Opaque<RalColorOptionType, RalColorOptionType.Encoded>()(
  S
    .Struct({
      ...Struct.omit(RALColorOption.fields, ["timestamps"]),
      optionGroup: ConfiguratorOptionGroupEntryView
    })
    .annotate({ identifier: "RalColorOptionType" })
) {}

export declare namespace RalColorOptionType {
  export interface Encoded extends S.Struct.Encoded<typeof RalColorOptionType["fields"]> {}
}

export class TextInfoOptionType extends S.Opaque<TextInfoOptionType, TextInfoOptionType.Encoded>()(
  S
    .Struct({
      ...Struct.omit(TextInfoOption.fields, ["timestamps"]),
      optionGroup: ConfiguratorOptionGroupEntryView
    })
    .annotate({ identifier: "TextInfoOptionType" })
) {}

export interface ListOptionItemImage {
  listOptionItemId: string | null
  imageUrl: string
}

export declare namespace TextInfoOptionType {
  export interface Encoded extends S.Struct.Encoded<typeof TextInfoOptionType["fields"]> {}
}

export const ConfiguratorOption = S.Union([
  ListOptionType,
  NumberOptionType,
  TextOptionType,
  RalColorOptionType,
  TextInfoOptionType
])
export type ConfiguratorOption = typeof ConfiguratorOption.Type
export namespace ConfiguratorOption {
  export type Encoded = typeof ConfiguratorOption.Encoded
}

export class OptionGroup extends S.Opaque<OptionGroup, OptionGroup.Encoded>()(
  S
    .Struct({
      ...Struct.omit(ConfiguratorOptionGroup.fields, ["timestamps", "options"]),
      options: S.Array(ConfiguratorOption)
    })
    .annotate({ identifier: "OptionGroup" })
) {}
export declare namespace OptionGroup {
  export interface Encoded extends S.Struct.Encoded<typeof OptionGroup["fields"]> {}
}

export interface ConditionGroup {
  id: string
  title: string
  isEnabled: boolean
  note: string | null
  conditions: readonly Condition[]
}

export interface Condition {
  id: string
  ruleValidationMode: RuleValidationMode
  rules: ConditionRule[]
  actions: ConditionAction[]
}

// TODO: string literal union
export enum RuleValidationMode {
  MatchAll = "MATCH_ALL",
  MatchAny = "MATCH_ANY"
}

export interface ConditionRule {
  id: string
  /*
   * Discriminator for what the rule targets. When "group", the chosen group id(s)
   * live in `comparisonValue` (single id for ==/!=, CSV for in/not_in); `option`
   * stays null. When "option", the option lives in `option` and `comparisonValue`
   * holds the user-typed comparison.
   */
  targetKind: "option" | "group"
  option: MiniOption | null
  comparisonValue: string
  comparisonOperator: RuleComparisonOperator
}

// TODO: string literal union
export enum RuleComparisonOperator {
  Equal = "==",
  NotEqual = "!=",
  Less = "<",
  LessOrEqual = "<=",
  Greater = ">",
  GreaterOrEqual = ">=",
  In = "in",
  NotIn = "not_in",
  Changes = "changes"
}

export type MiniOption =
  | Omit<ListOptionType, "optionGroup">
  | Omit<NumberOptionType, "optionGroup">
  | Omit<TextOptionType, "optionGroup">
  | Omit<RalColorOptionType, "optionGroup">
  | Omit<TextInfoOptionType, "optionGroup">

export interface MiniOptionGroup {
  id: string
  name: string
}

export interface ConditionAction {
  id: string
  option: MiniOption | null
  type: ActionType
  typeValue: string | null
}

// TODO: string literal union
export enum ActionType {
  /**
   * base option
   */
  OptionHide = "OPTION_HIDE",
  OptionShow = "OPTION_SHOW",
  OptionSetValue = "OPTION_SET_VALUE",
  OptionSetDefaultValue = "OPTION_SET_DEFAULT_VALUE",
  OptionAddCustomerNote = "OPTION_ADD_CUSTOMER_NOTE",
  OptionSetReadonly = "OPTION_SET_READONLY",
  OptionPriceUpdate = "OPTION_PRICE_UPDATE",
  OptionSetPriceTable = "OPTION_SET_PRICE_TABLE",
  OptionSetPriceFormula = "OPTION_SET_PRICE_FORMULA",
  OptionSetTooltip = "OPTION_SET_TOOLTIP",
  OptionSetFocussedImageUrl = "OPTION_SET_FOCUSSED_IMAGE_URL",

  /**
   * number option
   */
  NumberOptionSetMinVal = "NUMBER_OPTION_SET_MIN_VAL",
  NumberOptionSetMaxVal = "NUMBER_OPTION_SET_MAX_VAL",
  NumberOptionSetStepSize = "NUMBER_OPTION_SET_STEP_SIZE",
  NumberOptionSetStepPrice = "NUMBER_OPTION_SET_STEP_PRICE",
  NumberOptionSetStepPriceDescription = "NUMBER_OPTION_SET_STEP_PRICE_DESCRIPTION",

  /**
   * list option
   */
  ListOptionEnableItem = "LIST_OPTION_ENABLE_ITEM",
  ListOptionDisableItem = "LIST_OPTION_DISABLE_ITEM",
  ListOptionChangeItemImage = "LIST_OPTION_CHANGE_ITEM_IMAGE",

  /**
   * subtotal
   */
  SubtotalShow = "SUBTOTAL_SHOW"
}

export type useClosestValue = "Next" | "Previous"

export interface PriceTable {
  id: string
  name: string
  hasColumns: boolean
  columnOption: ConfiguratorOptionEntryView | null
  columnUseClosestValue: useClosestValue | null
  hasRows: boolean
  rowOption: ConfiguratorOptionEntryView | null
  rowUseClosestValue: useClosestValue | null
  items: readonly ConfiguratorPriceTableItem[]
}

export interface RalColor {
  id: string
  value: number
  name: string
  isEnabled: boolean

  // color is a HEX or RGB color code
  color: string
}
